package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetRowHeadersAndValues
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrixWithHeaders
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItemJson
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

class GetQuestionItemJsonListUseCase(
    private val spreadsheetApi: SpreadsheetApi,
) {
    suspend operator fun invoke(spreadsheetId: String, sheetId: String): Result<List<QuestionItemJson>> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = spreadsheetId, sheetId = sheetId)
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrixWithHeaders()
                    .map { list: List<GoogleSheetRowHeadersAndValues> ->
                        list.map {
                            QuestionItemJson(
                                list = it.listNoIndexes,
                                index = it.index,
                            )
                        }
                    }
                    .map {
                        Result.success(it)
                    }
                    .first()
            }
}
